var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 6.66602C23.2546 6.66602 26.011 7.79974 28.2666 10.0664C30.3235 12.1133 31.4467 14.5721 31.6369 17.4425C31.6705 17.9493 32.0489 18.3696 32.5441 18.4823C34.0774 18.8311 35.3736 19.6147 36.4326 20.833C37.6993 22.2552 38.333 23.9219 38.333 25.833C38.333 27.9218 37.6049 29.6939 36.1494 31.1494C34.6939 32.6049 32.9218 33.333 30.833 33.333H10.833C8.29979 33.333 6.13845 32.4611 4.34961 30.7168C2.56073 28.9613 1.66603 26.822 1.66602 24.2998C1.66602 22.1332 2.31628 20.2 3.61621 18.5C4.80393 16.96 6.31991 15.9259 8.16414 15.398C8.52092 15.2959 8.80727 15.0247 8.92188 14.6717C9.66573 12.3809 10.9973 10.5068 12.916 9.0498C15.0048 7.46101 17.3659 6.66611 19.999 6.66602Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.6546d957e774f48bf5aa3d5ef97a6d00.svg";
export { ForwardRef as ReactComponent };